module.exports = __webpack_public_path__ + "static/media/oeil.1b636f05.svg";